export function getUtmQueryString() {
  try {
    const utms = JSON.parse(localStorage.getItem("utm_params") || "{}");
    const pairs = Object.entries(utms);
    if (!pairs.length) return "";
    return (
      "?" +
      pairs
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join("&")
    );
  } catch {
    return "";
  }
}
